var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3137 10.0596H10.6553L10.422 9.83464C11.422 8.66798 11.9387 7.07631 11.6553 5.38464C11.2637 3.06798 9.33034 1.21798 6.99701 0.934644C3.47201 0.501311 0.505339 3.46798 0.938672 6.99298C1.22201 9.32631 3.07201 11.2596 5.38867 11.6513C7.08034 11.9346 8.67201 11.418 9.83867 10.418L10.0637 10.6513V11.3096L13.6053 14.8513C13.947 15.193 14.5053 15.193 14.847 14.8513C15.1887 14.5096 15.1887 13.9513 14.847 13.6096L11.3137 10.0596ZM6.31367 10.0596C4.23867 10.0596 2.56367 8.38464 2.56367 6.30964C2.56367 4.23464 4.23867 2.55964 6.31367 2.55964C8.38867 2.55964 10.0637 4.23464 10.0637 6.30964C10.0637 8.38464 8.38867 10.0596 6.31367 10.0596Z",
    fill: "#378EF0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon_search.c417624833cd10c2e40d88330de28c3f.svg";
export { ForwardRef as ReactComponent };